// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/mns-core-ui-footer/templates/footer/styles.scss
 ** module id = 25
 ** module chunks = 0
 **/